import { render, staticRenderFns } from "./WorkWithUs.vue?vue&type=template&id=79851eb6&"
import script from "./WorkWithUs.vue?vue&type=script&lang=js&"
export * from "./WorkWithUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports